import { Cartesian3 } from "cesium";
import { BaseHorizontalAlignmentSegment } from "./horizontal-alignment-base-segment";
import { CurveDataType, } from "./interface";
import { QuadraticBezierSegment } from "../../geometric-elements/quadratic-bezier";
import { CurveType } from "../../geometric-elements/interface";
export class HAQuadraticBezier extends BaseHorizontalAlignmentSegment {
    type = CurveDataType.QUADRATIC_BEZIER;
    points;
    element;
    get data() {
        throw new Error("Method not implemented.");
    }
    get surveyPoints() {
        return this.points;
    }
    constructor(points) {
        super();
        this.points = points;
        this.recomputeElement();
    }
    get startPoint() {
        return this.points[0];
    }
    get endPoint() {
        return this.points[this.points.length - 1];
    }
    isStartPoint(pointId) {
        return this.points[0].id === pointId;
    }
    isEndPoint(pointId) {
        return this.points[this.points.length - 1].id === pointId;
    }
    dispose() {
        // it should dispose the previous and next segment if they are quadratic linear connecting curve
        if (this.previous) {
            this.previous.next = this.next;
        }
        if (this.next) {
            this.next.previous = this.previous;
        }
        this.element?.dispose();
        this.points = undefined;
    }
    containsPointId(pointId) {
        return this.points.some((p) => p.id === pointId);
    }
    recomputeElement() {
        this.element?.dispose();
        // Previous affects next, not the other way around
        if (this.next?.type === CurveDataType.LINEAR) {
            // always this case
            const nextIPPoint = this.next.endPoint;
            const midPoint = Cartesian3.midpoint(this.points[this.points.length - 2].localPoint, nextIPPoint.localPoint, new Cartesian3());
            Cartesian3.clone(midPoint, this.points[this.points.length - 1].localPoint);
        }
        this.element = QuadraticBezierSegment.fromData({
            points: this.points.map((p) => new Cartesian3(p.localPoint.x, p.localPoint.y, 0)),
            type: CurveType.QUADRATIC_BEZIER,
        });
    }
}
//# sourceMappingURL=horizontal-alignment-quadratic-bezier.js.map